import React from "react";
import { makeStyles } from "@mui/styles";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";

// Speech during the assessment where talking isn't expected (see v2-user-backend
// utils/readingAloud.js). Two kinds, neither aborts the test:
// - "talking": speech that isn't proven to be the question - a reminder of the rule only, worded
//   neutrally (it may be someone else in the room); not counted.
// - "readingAloud": what was said matched the question's own words - a warning, counted
//   server-side (talkingcount, reading_aloud_flag) for reviewers.
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(3, 4, 3),
    borderRadius: "15px",
    width: "420px",
    maxWidth: "90vw",
    outline: "none",
    textAlign: "center",
    // Above the backdrop (zIndex 99998), or the backdrop covers the card and swallows the OK click.
    zIndex: 99999,
    position: "relative",
  },
  icon: {
    fontSize: "48px",
    marginBottom: "10px",
  },
  title: {
    color: "#d32f2f",
    marginBottom: "15px",
    fontWeight: "bold",
  },
  description: {
    marginBottom: "20px",
    lineHeight: 1.6,
    fontSize: "14px",
    color: "#333",
  },
}));

export default function SpeechAlertModal({ kind, onConfirm }) {
  const open = kind === "talking" || kind === "readingAloud";
  const readingAloud = kind === "readingAloud";
  const classes = useStyles();

  return (
    <Modal
      open={open}
      disableEnforceFocus={true}
      disableEscapeKeyDown={true}
      aria-labelledby="speech-alert-modal"
      className={classes.modal}
      style={{ zIndex: 99999 }}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 500, style: { zIndex: 99998 } } }}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <div className={classes.icon}>{"⚠️"}</div>
          <h3 id="speech-alert-modal" className={classes.title}>
            {readingAloud ? "Please don\u2019t read the questions aloud" : "Please don\u2019t talk during the assessment"}
          </h3>
          {readingAloud ? (
            <p className={classes.description}>
              We detected you <strong>reading this question aloud</strong>. Reading questions to anyone,
              including voice assistants, is <strong>not allowed</strong>.
              <br />
              <br />
              This has been recorded for review.
            </p>
          ) : (
            <p className={classes.description}>
              We noticed <strong>speaking</strong> near you. Talking or reading questions aloud is{" "}
              <strong>not allowed</strong> during the assessment. Please continue quietly.
            </p>
          )}
          <button type="button" className="btn btn-blue" onClick={onConfirm}>
            OK
          </button>
        </div>
      </Fade>
    </Modal>
  );
}
